var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('loading',{attrs:{"active":_vm.$store.state.isLoading,"can-cancel":false,"is-full-page":true}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }